<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12 col-md-9 col-lg-9">
        <h1 class="title-default">Automações de vendas</h1>
        <p class="welcome-message">
          <button mat-icon-button routerLink="/configuracoes/vendas" matTooltip="Voltar">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Escolha as automações que você quer ativar. Em seguida, defina o momento em que cada ação deve acontecer.
        </p>
      </div>
      <div class="col-12 col-md-3 col-lg-3 header-actions">
        @if (!mostrarComoFunciona) {
        <button mat-button type="button" (click)="aoVerComoFunciona()">
          <mat-icon class="material-symbols-outlined">help</mat-icon>
          Como funciona
        </button>
        }
      </div>
    </div>

    @if (isLoading) {
    <app-loading-box height="60" width="100%"></app-loading-box>
    <app-loading-box height="72" width="100%" marginTop="12"></app-loading-box>
    <app-loading-box height="72" width="100%" marginTop="12"></app-loading-box>
    <app-loading-box height="72" width="100%" marginTop="12"></app-loading-box>
    <app-loading-box height="72" width="100%" marginTop="12"></app-loading-box>
    }
    @else {

    @if (mostrarComoFunciona) {
    <div class="intro-block">
      <div class="intro-head">
        <img src="assets/img/empty-list.png" alt="" class="intro-mascote" onerror="this.style.display='none'">
        <div class="intro-copy">
          <strong>Como funciona</strong>
          <p>Três passos para automatizar as etapas que hoje você faz manualmente. Cada automação age só no momento que
            você definir, e você pode desativar ou trocar o gatilho depois.</p>
        </div>
        <button mat-flat-button class="btn-primary" type="button" (click)="aoComecar()">
          <mat-icon class="material-symbols-outlined">autorenew</mat-icon>
          Começar a automatizar
        </button>
      </div>

      <!-- Grade dos 3 Cards Ilustrativos -->
      <div class="intro-cards-grid">
        <!-- Card 1 -->
        <div class="intro-card">
          <div class="intro-card-illustration">
            <div class="intro-mock-box">
              <div class="intro-mock-row"><span class="mock-toggle"></span><span class="mock-line"></span></div>
              <div class="intro-mock-row"><span class="mock-toggle"></span><span class="mock-line"></span></div>
              <div class="intro-mock-row intro-mock-row--active">
                <span class="mock-toggle mock-toggle--on"></span>
                <span class="mock-line"></span>
                <mat-icon class="mock-cursor">arrow_selector_tool</mat-icon>
              </div>
            </div>
          </div>
          <div class="intro-card-step">
            <span class="step-num">1</span>
            <p>Ligue as <strong>etapas do fluxo</strong> que você quer automatizar.</p>
          </div>
        </div>

        <!-- Card 2 -->
        <div class="intro-card">
          <div class="intro-card-illustration intro-card-illustration--row">
            <span class="mock-toggle mock-toggle--on"></span>
            <span class="mock-connector-line"></span>
            <div class="mock-select-stack">
              <div class="mock-select-item"></div>
              <div class="mock-select-item"></div>
              <div class="mock-select-item mock-select-item--active">
                <mat-icon>bolt</mat-icon>
              </div>
            </div>
          </div>
          <div class="intro-card-step">
            <span class="step-num">2</span>
            <p>Escolha <strong>quando</strong> cada ação deve acontecer.</p>
          </div>
        </div>

        <!-- Card 3 -->
        <div class="intro-card">
          <div class="intro-card-illustration">
            <div class="mock-columns-stack">
              <div class="mock-col mock-col--1"><mat-icon>check_circle</mat-icon></div>
              <div class="mock-col mock-col--2"><mat-icon>check_circle</mat-icon></div>
              <div class="mock-col mock-col--3"><mat-icon>check_circle</mat-icon></div>
              <div class="mock-col mock-col--4"><mat-icon>check_circle</mat-icon></div>
            </div>
          </div>
          <div class="intro-card-step">
            <span class="step-num">3</span>
            <p>Salve e o sistema passa a <strong>executar essas etapas</strong> para você.</p>
          </div>
        </div>
      </div>

      @if (nenhumaAutomacaoAtiva) {
      <p class="empty-hint">Nenhuma automação está ativa neste momento.</p>
      }
    </div>
    } @else {

    <app-alert-card type="warning" title="Lembre-se de salvar suas automações">
      Nada passa a valer no sistema antes de você salvar.
    </app-alert-card>
    <app-alert-card type="info">
      Pausar uma automação não afeta pedidos já processados — vale apenas para os próximos.
    </app-alert-card>

    <div [formGroup]="model">

      <!-- ======================= Faturamento e logística ======================= -->
      <section class="section-container">
        <div class="section-title section-title--toggle section-title-actions" (click)="toggleSecao('faturamento')"
          style="cursor: pointer;">
          <div class="d-flex align-items-center gap-2">
            <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
            <span>Faturamento e logística</span>
          </div>
          <div class="d-flex align-items-center gap-2 ms-auto">
            <span class="status-badge badge-cinza">{{ ativasFaturamento }}</span>
            <mat-icon class="material-symbols-outlined section-chevron"
              [class.section-chevron--open]="secoesAbertas.faturamento">
              expand_more
            </mat-icon>
          </div>
        </div>
        <p class="section-sub-title">Da aprovação do pedido à expedição: nota fiscal, estoque e movimentação. Ative e
          escolha o gatilho de cada ação.</p>
        @if (secoesAbertas.faturamento) {
        <div class="automation-list">

          <!-- Emitir Nota Fiscal Eletrônica (NF-e) -->
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon class="material-symbols-outlined">description</mat-icon></span>
              <div class="identity-copy">
                <strong>Emitir Nota Fiscal Eletrônica (NF-e)</strong>
                <p>O sistema emite a NF-e automaticamente, sem intervenção manual.</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card" [class.config-card--invalid]="model.get('gatilhoEmissaoNFe')?.invalid">
              <div class="inline-control">
                <span>Quando</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                  <mat-label>Selecione o gatilho</mat-label>
                  <mat-select formControlName="gatilhoEmissaoNFe" [compareWith]="compararGatilhos">
                    @for (opcao of respostaAtual?.opcoesEmissaoNFe; track opcao.idOpcaoAutomacao) {
                    @if (opcao.idOpcaoAutomacao !== opcaoTransicaoEtapaEnum.EmissaoNFe) {
                    <mat-option [value]="{ idOpcao: opcao.idOpcaoAutomacao, idEtapaKanban: null }">{{ opcao.rotulo
                      }}</mat-option>
                    }
                    }
                    <mat-optgroup label="Transição de etapa">
                      @for (etapa of etapasDoProcesso(tipoProcessoKanbanEnum.PedidoDeVenda); track
                      etapa.idEtapaKanban) {
                      <mat-option
                        [value]="{ idOpcao: opcaoTransicaoEtapaEnum.EmissaoNFe, idEtapaKanban: etapa.idEtapaKanban }">Ao
                        mover o pedido para {{ etapa.nome }}</mat-option>
                      }
                    </mat-optgroup>
                  </mat-select>
                  @if (model.get('gatilhoEmissaoNFe')?.invalid) {
                  <mat-error>Escolha o gatilho para manter esta automação ativa.</mat-error>
                  }
                </mat-form-field>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoEmissaoNFe"
                color="primary"></mat-slide-toggle>
            </div>
          </div>

          <!-- Autorizar Nota Fiscal Eletrônica (NF-e) na Sefaz -->
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon class="material-symbols-outlined">verified</mat-icon></span>
              <div class="identity-copy">
                <strong>Autorizar Nota Fiscal Eletrônica (NF-e) na Sefaz</strong>
                <p>Quando configurada, o sistema envia a NF-e para autorização na Sefaz automaticamente.</p>
                @if (avisoDependencia('isAtivoAutorizacaoNFe')) {
                <p class="warning-hint"><mat-icon class="material-symbols-outlined">warning</mat-icon>{{
                  avisoDependencia('isAtivoAutorizacaoNFe') }}</p>
                }
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card" [class.config-card--invalid]="model.get('gatilhoAutorizacaoNFe')?.invalid">
              <div class="inline-control">
                <span>Quando</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                  <mat-label>Selecione o gatilho</mat-label>
                  <mat-select formControlName="gatilhoAutorizacaoNFe" [compareWith]="compararGatilhos">
                    @for (opcao of respostaAtual?.opcoesAutorizacaoNFe; track opcao.idOpcaoAutomacao) {
                    @if (opcao.idOpcaoAutomacao !== opcaoTransicaoEtapaEnum.AutorizacaoNFe &&
                    !(opcao.isDependeSeparacao
                    &&
                    !trabalhaComSeparacao)) {
                    <mat-option [value]="{ idOpcao: opcao.idOpcaoAutomacao, idEtapaKanban: null }">{{ opcao.rotulo
                      }}</mat-option>
                    }
                    }
                    <mat-optgroup label="Transição de etapa">
                      @for (etapa of etapasDoProcesso(tipoProcessoKanbanEnum.PedidoDeVenda); track
                      etapa.idEtapaKanban) {
                      <mat-option
                        [value]="{ idOpcao: opcaoTransicaoEtapaEnum.AutorizacaoNFe, idEtapaKanban: etapa.idEtapaKanban }">Ao
                        mover o pedido para {{ etapa.nome }}</mat-option>
                      }
                    </mat-optgroup>
                  </mat-select>
                  @if (model.get('gatilhoAutorizacaoNFe')?.invalid) {
                  <mat-error>Escolha o gatilho para manter esta automação ativa.</mat-error>
                  }
                </mat-form-field>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoAutorizacaoNFe"
                color="primary"></mat-slide-toggle>
            </div>
          </div>

          <!-- Lançar saída de estoque -->
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon class="material-symbols-outlined">inventory_2</mat-icon></span>
              <div class="identity-copy">
                <strong>Lançar saída de estoque</strong>
                <p>Lança a saída de estoque dos itens do pedido no gatilho escolhido.</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card" [class.config-card--invalid]="model.get('gatilhoSaidaEstoque')?.invalid">
              <div class="inline-control">
                <span>Quando</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                  <mat-label>Selecione o gatilho</mat-label>
                  <mat-select formControlName="gatilhoSaidaEstoque" [compareWith]="compararGatilhos">
                    @for (opcao of respostaAtual?.opcoesSaidaEstoque; track opcao.idOpcaoAutomacao) {
                    @if (opcao.idOpcaoAutomacao !== opcaoTransicaoEtapaEnum.SaidaEstoque && !(opcao.isDependeExpedicao
                    &&
                    !trabalhaComExpedicao)) {
                    <mat-option [value]="{ idOpcao: opcao.idOpcaoAutomacao, idEtapaKanban: null }">{{ opcao.rotulo
                      }}</mat-option>
                    }
                    }
                    <mat-optgroup label="Transição de etapa">
                      @for (etapa of etapasDoProcesso(tipoProcessoKanbanEnum.PedidoDeVenda); track
                      etapa.idEtapaKanban) {
                      <mat-option
                        [value]="{ idOpcao: opcaoTransicaoEtapaEnum.SaidaEstoque, idEtapaKanban: etapa.idEtapaKanban }">Ao
                        mover o pedido para {{ etapa.nome }}</mat-option>
                      }
                    </mat-optgroup>
                  </mat-select>
                  @if (model.get('gatilhoSaidaEstoque')?.invalid) {
                  <mat-error>Escolha o gatilho para manter esta automação ativa.</mat-error>
                  }
                </mat-form-field>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoSaidaEstoque"
                color="primary"></mat-slide-toggle>
            </div>
          </div>

          <!-- Imprimir etiqueta de envio -->
          @if (trabalhaComExpedicao) {
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon class="material-symbols-outlined">print</mat-icon></span>
              <div class="identity-copy">
                <strong>Imprimir etiqueta de envio</strong>
                <p>O sistema dispara automaticamente a impressão da etiqueta de envio.</p>
                @if (avisoDependencia('isAtivoEtiquetaEnvio')) {
                <p class="warning-hint"><mat-icon class="material-symbols-outlined">warning</mat-icon>{{
                  avisoDependencia('isAtivoEtiquetaEnvio') }}</p>
                }
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card" [class.config-card--invalid]="model.get('idOpcaoEtiquetaEnvio')?.invalid">
              <div class="inline-control">
                <span>Quando</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                  <mat-label>Selecione o gatilho</mat-label>
                  <mat-select formControlName="idOpcaoEtiquetaEnvio">
                    @for (opcao of respostaAtual?.opcoesEtiquetaEnvio; track opcao.idOpcaoAutomacao) {
                    <mat-option [value]="opcao.idOpcaoAutomacao">{{ opcao.rotulo }}</mat-option>
                    }
                  </mat-select>
                  @if (model.get('idOpcaoEtiquetaEnvio')?.invalid) {
                  <mat-error>Escolha o gatilho para manter esta automação ativa.</mat-error>
                  }
                </mat-form-field>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoEtiquetaEnvio"
                color="primary"></mat-slide-toggle>
            </div>
          </div>
          }

          <!-- Enviar para separação -->
          @if (trabalhaComSeparacao) {
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon class="material-symbols-outlined">view_kanban</mat-icon></span>
              <div class="identity-copy">
                <strong>Enviar para separação</strong>
                <p>O sistema move o card do pedido para a coluna de separação da faixa "Envio e retirada", com progresso
                  em 0%.</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card" [class.config-card--invalid]="model.get('gatilhoEnvioSeparacao')?.invalid">
              <div class="inline-control">
                <span>Quando</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                  <mat-label>Selecione o gatilho</mat-label>
                  <mat-select formControlName="gatilhoEnvioSeparacao" [compareWith]="compararGatilhos">
                    @for (opcao of respostaAtual?.opcoesEnvioSeparacao; track opcao.idOpcaoAutomacao) {
                    @if (opcao.idOpcaoAutomacao !== opcaoTransicaoEtapaEnum.EnvioSeparacao) {
                    <mat-option [value]="{ idOpcao: opcao.idOpcaoAutomacao, idEtapaKanban: null }">{{ opcao.rotulo
                      }}</mat-option>
                    }
                    }
                    <mat-optgroup label="Transição de etapa">
                      @for (etapa of etapasDoProcesso(tipoProcessoKanbanEnum.PedidoDeVenda); track
                      etapa.idEtapaKanban) {
                      <mat-option
                        [value]="{ idOpcao: opcaoTransicaoEtapaEnum.EnvioSeparacao, idEtapaKanban: etapa.idEtapaKanban }">Ao
                        mover o pedido para {{ etapa.nome }}</mat-option>
                      }
                    </mat-optgroup>
                  </mat-select>
                  @if (model.get('gatilhoEnvioSeparacao')?.invalid) {
                  <mat-error>Escolha o gatilho para manter esta automação ativa.</mat-error>
                  }
                </mat-form-field>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoEnvioSeparacao"
                color="primary"></mat-slide-toggle>
            </div>
          </div>
          }

          <!-- Enviar para expedição -->
          @if (trabalhaComExpedicao) {
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon class="material-symbols-outlined">local_shipping</mat-icon></span>
              <div class="identity-copy">
                <strong>Enviar para expedição</strong>
                <p>O sistema move o card do pedido para a coluna de expedição da faixa "Envio e retirada", com progresso
                  em 0%.</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card" [class.config-card--invalid]="model.get('gatilhoEnvioExpedicao')?.invalid">
              <div class="inline-control">
                <span>Quando</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                  <mat-label>Selecione o gatilho</mat-label>
                  <mat-select formControlName="gatilhoEnvioExpedicao" [compareWith]="compararGatilhos">
                    @for (opcao of respostaAtual?.opcoesEnvioExpedicao; track opcao.idOpcaoAutomacao) {
                    @if (opcao.idOpcaoAutomacao !== opcaoTransicaoEtapaEnum.EnvioExpedicao) {
                    <mat-option [value]="{ idOpcao: opcao.idOpcaoAutomacao, idEtapaKanban: null }">{{ opcao.rotulo
                      }}</mat-option>
                    }
                    }
                    <mat-optgroup label="Transição de etapa">
                      @for (etapa of etapasDoProcesso(tipoProcessoKanbanEnum.PedidoDeVenda); track
                      etapa.idEtapaKanban) {
                      <mat-option
                        [value]="{ idOpcao: opcaoTransicaoEtapaEnum.EnvioExpedicao, idEtapaKanban: etapa.idEtapaKanban }">Ao
                        mover o pedido para {{ etapa.nome }}</mat-option>
                      }
                    </mat-optgroup>
                  </mat-select>
                  @if (model.get('gatilhoEnvioExpedicao')?.invalid) {
                  <mat-error>Escolha o gatilho para manter esta automação ativa.</mat-error>
                  }
                </mat-form-field>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoEnvioExpedicao"
                color="primary"></mat-slide-toggle>
            </div>
          </div>
          }

        </div>
        }
      </section>

      <!-- ======================= Orçamento ======================= -->
      <section class="section-container">
        <div class="section-title section-title--toggle section-title-actions" (click)="toggleSecao('orcamento')"
          style="cursor: pointer;">
          <div class="d-flex align-items-center gap-2">
            <mat-icon class="material-symbols-outlined">request_quote</mat-icon>
            <span>Orçamento</span>
          </div>
          <div class="d-flex align-items-center gap-2 ms-auto">
            <span class="status-badge badge-cinza">{{ ativasOrcamento }}</span>
            <mat-icon class="material-symbols-outlined section-chevron"
              [class.section-chevron--open]="secoesAbertas.orcamento">
              expand_more
            </mat-icon>
          </div>
        </div>
        <p class="section-sub-title">Conversão em pedido de venda e reserva de estoque.</p>

        @if (secoesAbertas.orcamento) {

        <div class="automation-list">

          <!-- Gerar pedido de venda automaticamente -->
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon class="material-symbols-outlined">move_down</mat-icon></span>
              <div class="identity-copy">
                <strong>Gerar pedido de venda automaticamente</strong>
                <p>O sistema executa a mesma rotina de "Gerar venda", incluindo as automações de conversão configuradas
                  abaixo.</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card" [class.config-card--invalid]="model.get('gatilhoGeracaoPedido')?.invalid">
              <div class="inline-control">
                <span>Quando</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                  <mat-label>Selecione o gatilho</mat-label>
                  <mat-select formControlName="gatilhoGeracaoPedido" [compareWith]="compararGatilhos">
                    <mat-optgroup label="Transição de etapa">
                      @for (etapa of etapasDoProcesso(tipoProcessoKanbanEnum.Orcamento); track etapa.idEtapaKanban) {
                      <mat-option
                        [value]="{ idOpcao: opcaoTransicaoEtapaEnum.GeracaoPedido, idEtapaKanban: etapa.idEtapaKanban }">Ao
                        mover o orçamento para {{ etapa.nome }}</mat-option>
                      }
                    </mat-optgroup>
                  </mat-select>
                  @if (model.get('gatilhoGeracaoPedido')?.invalid) {
                  <mat-error>Escolha o gatilho para manter esta automação ativa.</mat-error>
                  }
                </mat-form-field>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoGeracaoPedido"
                color="primary"></mat-slide-toggle>
            </div>
          </div>

          <!-- Reservar estoque do orçamento -->
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon class="material-symbols-outlined">inventory</mat-icon></span>
              <div class="identity-copy">
                <strong>Reservar estoque do orçamento</strong>
                <p>O sistema reserva o estoque dos itens no depósito do orçamento. Se o orçamento tiver validade, a
                  reserva herda essa data e é liberada automaticamente depois do vencimento. Ao converter o orçamento
                  em pedido, a reserva passa para o pedido.</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card"
              [class.config-card--invalid]="model.get('gatilhoReservaEstoqueOrcamento')?.invalid">
              <div class="inline-control">
                <span>Quando</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                  <mat-label>Selecione o gatilho</mat-label>
                  <mat-select formControlName="gatilhoReservaEstoqueOrcamento" [compareWith]="compararGatilhos">
                    @for (opcao of respostaAtual?.opcoesReservaEstoqueOrcamento; track opcao.idOpcaoAutomacao) {
                    @if (opcao.idOpcaoAutomacao !== opcaoTransicaoEtapaEnum.ReservaEstoqueOrcamento) {
                    <mat-option [value]="{ idOpcao: opcao.idOpcaoAutomacao, idEtapaKanban: null }">{{ opcao.rotulo
                      }}</mat-option>
                    }
                    }
                    <mat-optgroup label="Transição de etapa">
                      @for (etapa of etapasDoProcesso(tipoProcessoKanbanEnum.Orcamento); track etapa.idEtapaKanban) {
                      <mat-option
                        [value]="{ idOpcao: opcaoTransicaoEtapaEnum.ReservaEstoqueOrcamento, idEtapaKanban: etapa.idEtapaKanban }">Ao
                        mover o orçamento para {{ etapa.nome }}</mat-option>
                      }
                    </mat-optgroup>
                  </mat-select>
                  @if (model.get('gatilhoReservaEstoqueOrcamento')?.invalid) {
                  <mat-error>Escolha o gatilho para manter esta automação ativa.</mat-error>
                  }
                </mat-form-field>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoReservaEstoqueOrcamento"
                color="primary"></mat-slide-toggle>
            </div>
          </div>

        </div>
        }
      </section>

      <!-- ======================= Pedido de venda ======================= -->
      <section class="section-container">
        <div class="section-title section-title--toggle section-title-actions" (click)="toggleSecao('pedido')"
          style="cursor: pointer;">
          <div class="d-flex align-items-center gap-2">
            <mat-icon class="material-symbols-outlined">bolt</mat-icon>
            <span>Pedido de venda</span>
          </div>
          <div class="d-flex align-items-center gap-2 ms-auto">
            <span class="status-badge badge-cinza">{{ ativasPedido }}</span>
            <mat-icon class="material-symbols-outlined section-chevron"
              [class.section-chevron--open]="secoesAbertas.pedido">
              expand_more
            </mat-icon>
          </div>
        </div>
        <p class="section-sub-title">Comportamentos do próprio pedido de venda, disparados pelo sistema.</p>
        @if (secoesAbertas.pedido) {
        <div class="automation-list">

          <!-- Reservar estoque do pedido de venda -->
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon class="material-symbols-outlined">inventory</mat-icon></span>
              <div class="identity-copy">
                <strong>Reservar estoque do pedido de venda</strong>
                <p>O sistema reserva o estoque dos itens no depósito do pedido. Itens que já vieram reservados do
                  orçamento são mantidos, sem duplicar, e deixam de ter validade. A reserva do pedido não vence: sai
                  pela liberação por prazo ou quando o pedido gera movimento de estoque.</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card" [class.config-card--invalid]="model.get('gatilhoReservaEstoquePedido')?.invalid">
              <div class="inline-control">
                <span>Quando</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                  <mat-label>Selecione o gatilho</mat-label>
                  <mat-select formControlName="gatilhoReservaEstoquePedido" [compareWith]="compararGatilhos">
                    @for (opcao of respostaAtual?.opcoesReservaEstoquePedido; track opcao.idOpcaoAutomacao) {
                    @if (opcao.idOpcaoAutomacao !== opcaoTransicaoEtapaEnum.ReservaEstoquePedido) {
                    <mat-option [value]="{ idOpcao: opcao.idOpcaoAutomacao, idEtapaKanban: null }">{{ opcao.rotulo
                      }}</mat-option>
                    }
                    }
                    <mat-optgroup label="Transição de etapa">
                      @for (etapa of etapasDoProcesso(tipoProcessoKanbanEnum.PedidoDeVenda); track
                      etapa.idEtapaKanban) {
                      <mat-option
                        [value]="{ idOpcao: opcaoTransicaoEtapaEnum.ReservaEstoquePedido, idEtapaKanban: etapa.idEtapaKanban }">Ao
                        mover o pedido para {{ etapa.nome }}</mat-option>
                      }
                    </mat-optgroup>
                  </mat-select>
                  @if (model.get('gatilhoReservaEstoquePedido')?.invalid) {
                  <mat-error>Escolha o gatilho para manter esta automação ativa.</mat-error>
                  }
                </mat-form-field>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoReservaEstoquePedido"
                color="primary"></mat-slide-toggle>
            </div>
          </div>

          <!-- Liberar reserva do pedido -->
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon class="material-symbols-outlined">timer_off</mat-icon></span>
              <div class="identity-copy">
                <strong>Liberar reserva do pedido</strong>
                <span class="ml-3 status-badge badge-azul">Tempo decorrido</span>
                <p>Passados os dias informados desde a emissão do pedido, o sistema libera a reserva de estoque ou
                  apenas notifica, conforme a ação escolhida. Vale mesmo para pedidos já faturados que ainda não
                  geraram movimento de estoque. Quando o pedido gera movimento de estoque, a reserva é removida
                  automaticamente.</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card config-card--stacked"
              [class.config-card--invalid]="model.get('idModoAoVencerLiberacaoReservaPedido')?.invalid || model.get('diasLiberacaoReservaPedido')?.invalid || model.get('destinatariosLiberacaoReservaPedido')?.invalid">
              <div class="stacked-header">
                <div class="inline-control">
                  <span>Contar de</span>
                  <div class="ref-box">Data de emissão do pedido</div>
                </div>
                <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoLiberacaoReservaPedido"
                  color="primary"></mat-slide-toggle>
              </div>
              <span class="divider"></span>
              <div class="inline-control">
                <span>Prazo</span>
                <div class="prazo-grid">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Dias</mat-label>
                    <input matInput [currencyMask]="integerMask" formControlName="diasLiberacaoReservaPedido">
                    <mat-error>Informe um número de dias maior que zero.</mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                    <mat-label>Ação ao vencer</mat-label>
                    <mat-select formControlName="idModoAoVencerLiberacaoReservaPedido">
                      <mat-option [value]="null">Selecione a ação</mat-option>
                      @for (opcao of opcoesAoVencer; track opcao.idOpcaoAutomacao) {
                      <mat-option [value]="opcao.idOpcaoAutomacao">{{ opcao.rotulo }}</mat-option>
                      }
                    </mat-select>
                    <mat-error>Escolha a ação ao vencer para manter esta automação ativa.</mat-error>
                  </mat-form-field>
                </div>
              </div>
              @if (model.get('idModoAoVencerLiberacaoReservaPedido')?.value === modoAoVencerEnum.ApenasNotificar) {
              <div class="inline-control">
                <span>Notificar</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">group</mat-icon>
                  <mat-label>Selecionar destinatários</mat-label>
                  <mat-select formControlName="destinatariosLiberacaoReservaPedido" multiple
                    panelClass="panel-com-busca">
                    <mat-select-trigger>
                      <span class="recipient-chips">
                        @for (chave of model.get('destinatariosLiberacaoReservaPedido')?.value; track chave) {
                        <span class="recipient-chip" [class.recipient-chip--dynamic]="metaDestinatario(chave).dinamico">
                          <mat-icon class="material-symbols-outlined">{{ metaDestinatario(chave).icon }}</mat-icon>{{
                          metaDestinatario(chave).label }}
                        </span>
                        }
                      </span>
                    </mat-select-trigger>

                    <div class="select-search-wrapper">
                      <input class="select-search-input inputSearchSelect" [(ngModel)]="buscaDestinatarioPedido"
                        autocomplete="off" [ngModelOptions]="{standalone: true}" placeholder="Pesquisar..."
                        (keydown)="$event.stopPropagation()" (keydown.enter)="$event.preventDefault()">
                    </div>

                    @if (filtrarDestinatarios(destinatariosDoCard, buscaDestinatarioPedido,
                    model.get('destinatariosLiberacaoReservaPedido')?.value).length > 0) {
                    <mat-optgroup label="Do card">
                      @for (destinatario of filtrarDestinatarios(destinatariosDoCard, buscaDestinatarioPedido,
                      model.get('destinatariosLiberacaoReservaPedido')?.value); track destinatario.valor) {
                      <mat-option [value]="destinatario.valor">{{ destinatario.label }}</mat-option>
                      }
                    </mat-optgroup>
                    }

                    @if (filtrarDestinatarios(destinatariosPorPerfil, buscaDestinatarioPedido,
                    model.get('destinatariosLiberacaoReservaPedido')?.value).length > 0) {
                    <mat-optgroup label="Por perfil">
                      @for (destinatario of filtrarDestinatarios(destinatariosPorPerfil, buscaDestinatarioPedido,
                      model.get('destinatariosLiberacaoReservaPedido')?.value); track destinatario.valor) {
                      <mat-option [value]="destinatario.valor">{{ destinatario.label }}</mat-option>
                      }
                    </mat-optgroup>
                    }

                    @if (filtrarDestinatarios(destinatariosPorUsuario, buscaDestinatarioPedido,
                    model.get('destinatariosLiberacaoReservaPedido')?.value).length > 0) {
                    <mat-optgroup label="Por usuário">
                      @for (destinatario of filtrarDestinatarios(destinatariosPorUsuario, buscaDestinatarioPedido,
                      model.get('destinatariosLiberacaoReservaPedido')?.value); track destinatario.valor) {
                      <mat-option [value]="destinatario.valor">{{ destinatario.label }}</mat-option>
                      }
                    </mat-optgroup>
                    }
                  </mat-select>
                  @if (model.get('destinatariosLiberacaoReservaPedido')?.invalid) {
                  <mat-error>Escolha ao menos um destinatário.</mat-error>
                  }
                </mat-form-field>
              </div>
              }
            </div>
          </div>

          <!-- Aviso de contas a receber em atraso -->
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon
                  class="material-symbols-outlined">notification_important</mat-icon></span>
              <div class="identity-copy">
                <strong>Aviso de contas a receber em atraso</strong>
                <p>O sistema avisa sobre o pedido quando a conta a receber passa do prazo escolhido.</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card" [class.config-card--invalid]="model.get('idOpcaoAvisoRecebimentoAtraso')?.invalid">
              <div class="inline-control">
                <span>Quando</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                  <mat-label>Selecione o gatilho</mat-label>
                  <mat-select formControlName="idOpcaoAvisoRecebimentoAtraso">
                    @for (opcao of respostaAtual?.opcoesAvisoRecebimentoAtraso; track opcao.idOpcaoAutomacao) {
                    <mat-option [value]="opcao.idOpcaoAutomacao">{{ opcao.rotulo }}</mat-option>
                    }
                  </mat-select>
                  @if (model.get('idOpcaoAvisoRecebimentoAtraso')?.invalid) {
                  <mat-error>Escolha o gatilho para manter esta automação ativa.</mat-error>
                  }
                </mat-form-field>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoAvisoRecebimentoAtraso"
                color="primary"></mat-slide-toggle>
            </div>
          </div>

          <!-- Inserir automaticamente a tag "1ª venda" -->
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon class="material-symbols-outlined">star</mat-icon></span>
              <div class="identity-copy">
                <strong>Inserir automaticamente a tag "1ª venda"</strong>
                <p>O sistema aplica a tag "1ª venda" ao pedido de um cliente sem histórico de compras.</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card config-card--small">
              <div class="when-box">
                <mat-icon class="material-symbols-outlined">bolt</mat-icon>
                <div><span>Quando</span><strong>Disparada por evento</strong></div>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoPrimeiraVenda"
                color="primary"></mat-slide-toggle>
            </div>
          </div>

          <!-- Enviar tags da venda para a nota fiscal -->
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon class="material-symbols-outlined">label</mat-icon></span>
              <div class="identity-copy">
                <strong>Enviar tags da venda para a nota fiscal</strong>
                <p>O sistema replica as tags do pedido para a nota fiscal.</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card config-card--small">
              <div class="when-box">
                <mat-icon class="material-symbols-outlined">bolt</mat-icon>
                <div><span>Quando</span><strong>Disparada por evento</strong></div>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoTagsNotaFiscal"
                color="primary"></mat-slide-toggle>
            </div>
          </div>

          <!-- Ao identificar o pagamento -->
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon"><mat-icon class="material-symbols-outlined">how_to_reg</mat-icon></span>
              <div class="identity-copy">
                <strong>Ao identificar o pagamento</strong>
                <span class="ml-3 status-badge badge-azul">Movimentação</span>
                <p>Move o card automaticamente para a etapa escolhida assim que o pagamento do pedido for
                  identificado.</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card" [class.config-card--invalid]="model.get('gatilhoAprovacaoPagamento')?.invalid">
              <div class="inline-control">
                <span>Quando</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                  <mat-label>Selecione a etapa</mat-label>
                  <mat-select formControlName="gatilhoAprovacaoPagamento" [compareWith]="compararGatilhos">
                    <mat-optgroup label="Transição de etapa">
                      @for (etapa of etapasDoProcesso(tipoProcessoKanbanEnum.PedidoDeVenda); track
                      etapa.idEtapaKanban) {
                      <mat-option
                        [value]="{ idOpcao: opcaoTransicaoEtapaEnum.AprovacaoPagamento, idEtapaKanban: etapa.idEtapaKanban }">Mover
                        o card para {{ etapa.nome }}</mat-option>
                      }
                    </mat-optgroup>
                  </mat-select>
                  @if (model.get('gatilhoAprovacaoPagamento')?.invalid) {
                  <mat-error>Escolha a etapa de destino para manter esta automação ativa.</mat-error>
                  }
                </mat-form-field>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivoAprovacaoPagamento"
                color="primary"></mat-slide-toggle>
            </div>
          </div>

        </div>
        }
      </section>

    </div>

    <app-footer-action [isLoadingSalvar]="salvando" [isSalvarDisabled]="salvando" salvarLabel="Salvar automações"
      (salvar)="salvar()" (cancelar)="descartar()">
    </app-footer-action>

    }
    }
  </div>
</div>